// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__WFtDk","error":"Textarea_error__2CaPU","readonly":"Textarea_readonly__3i2KM","disabled":"Textarea_disabled__2Taj5"};